import { getTranslation, getTranslatedErrorMessage } from 'network/messageTranslationHelpers/index'
import { ErrorMessage, errorCodeToMessage } from 'network/messageTranslationHelpers/messages'
import { getAuthToken, signOut } from 'utils/common-services/cookie.service'
import { openErrorToaster, openSuccessToaster } from 'utils/common-services/toaster.service'

const resolveApiErrorMessage = (error) => {
  if (!error) return getTranslation(ErrorMessage.internalServerError)
  if (error.description) {
    return error.description
  }
  if (error.errorCode != null && errorCodeToMessage.has(error.errorCode)) {
    return getTranslatedErrorMessage(error.errorCode)
  }
  return getTranslation(ErrorMessage.internalServerError)
}

export const requestHandler = (request) => {
  if (request.handlerEnabled) {
    const authToken = getAuthToken()
    if (authToken) {
      request.headers.authorization = `Bearer ${authToken}`
    }
  }
  // Loader Logic to add loader
  // if (request.loader) {
  //   store.dispatch(startLoader(request.loader))
  // }
  return request
}

export const responseSuccessHandler = (response) => {
  const { responseType = 'json', successMessage, suppressErrorToast = false } = response.config || {}

  if (responseType === 'blob') {
    return { file: response.data, headers: response.headers }
  }

  const { data, errors } = response.data || {}
  // Defensive: treat 200 responses with errors as failures (e.g. operator callback errors returned with 200)
  if (errors && Array.isArray(errors) && errors.length > 0) {
    if (!suppressErrorToast) {
      const errorMessage = resolveApiErrorMessage(errors[0])
      openErrorToaster({ message: errorMessage })
    }
    return Promise.reject(errors)
  }

  successMessage && openSuccessToaster({ message: getTranslation(successMessage) })
  return data ?? response.data
}

export const errorHandler = (error) => {
  const suppressErrorToast = error?.config?.suppressErrorToast === true

  if (!error.response) {
    if (!suppressErrorToast) {
      openErrorToaster({ message: getTranslation(ErrorMessage.internalServerError) })
    }
    return Promise.reject(error)
  }
  if (error.response.status === 401) {
    // Snackbar UnAuthed
    openErrorToaster({ message: getTranslation(ErrorMessage.unAuthorized) })
    signOut()
    // store.dispatch(stopLoader(error.response.config.loader))
    return Promise.reject(error.response.data.errors)
  }

  const errors = error.response.data?.errors
  const errorMessage = resolveApiErrorMessage(errors?.[0])
  if (!suppressErrorToast) {
    openErrorToaster({ message: errorMessage })
  }
  return Promise.reject(errors || [{ description: errorMessage }])
  //  else if (error.response.status === 500) {
  //   // Snackbar Internal Server Error
  //   openErrorToaster({ message: getTranslation(ErrorMessage.internalServerError) })
  //   // store.dispatch(stopLoader(error.response.config.loader))
  //   return Promise.reject(error.response.data.errors)
  // }
  // Other errors
  // if (error.response.config.loader) {
  // store.dispatch(stopLoader(error.response.config.loader))
  // }

  // Open Error Toaster
  // const apiErrorCode = error.response.data.errors[0].errorCode

  // if (error.response.config.url === 'user/login') {
  //   console.log("CHALA")
  //   <Redirect to='/' />
  // }
}
